import {
  CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "./renderConfig";
import { buildCsv } from "./agentServiceTimeExport";

const SUMMARY_HEADERS = Object.freeze([
  "Branch",
  "Avg Total / Day",
  "Avg Min / Hour",
  "Avg Max / Hour",
  "Avg / Hour",
  "Abandonment %",
  "Peak Hour",
]);
const BREAKDOWN_HEADERS = Object.freeze(["Branch", "Hour", "Customers"]);

const toPrimitiveNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getPointPeriod = (point) => point.date ?? point.day ?? point.name ?? point.hour ?? "";

export const getCustomersInBranchRows = (scopes = [], renderConfig) => {
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  });
  return sortReportRows(scopes, config, {
    columnDefinitions: CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  });
};

export const getCustomersInBranchSummaryCsvRows = (scopes = [], renderConfig) =>
  getCustomersInBranchRows(scopes, renderConfig).map((row) => [
    row.scopeName || row.branchName || "",
    toPrimitiveNumber(row.total),
    toPrimitiveNumber(row.min),
    toPrimitiveNumber(row.max),
    toPrimitiveNumber(row.average),
    toPrimitiveNumber(row.abondonmentRate),
    row.peakHour || "",
  ]);

export const getCustomersInBranchBreakdownCsvRows = (scopes = [], renderConfig) =>
  getCustomersInBranchRows(scopes, renderConfig).flatMap((row) =>
    (row.chart || []).map((point) => [
      row.scopeName || row.branchName || "",
      getPointPeriod(point),
      toPrimitiveNumber(point.total ?? point.value ?? point.count),
    ])
  );

const triggerCsvDownload = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadCustomersInBranchCsvFiles = ({ scopes, renderConfig, filenamePrefix }) => {
  triggerCsvDownload(
    `${filenamePrefix}_summary.csv`,
    buildCsv(SUMMARY_HEADERS, getCustomersInBranchSummaryCsvRows(scopes, renderConfig))
  );
  triggerCsvDownload(
    `${filenamePrefix}_breakdown.csv`,
    buildCsv(BREAKDOWN_HEADERS, getCustomersInBranchBreakdownCsvRows(scopes, renderConfig))
  );
};
